import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { ProtocoloRenunciaPesquisaComponent } from "./consulta-protocolo/protocolo-renuncia-pesquisa.component";
import { RenunciaPesquisaComponent } from "./pesquisa/renuncia-pesquisa.component";
import { RenunciaCadastroComponent } from "./cadastro/renuncia-cadastro.component";
import { TarefasComponent } from "./tarefas/tarefas.component";
import { ListagemJanela } from "./tarefas/listagem-janela/listagem-janela.component";

const routes: Routes = [
  {
    path: 'renuncia/pesquisa',
    component: RenunciaPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
  },
  {
    path: 'renuncia/cadastro',
    component: RenunciaCadastroComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
  },
  {
    path: 'renuncia/tarefas',
    component: TarefasComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
  },
  {
    path: 'renuncia/tarefas/janela-renuncia',
    component: ListagemJanela,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
  },
  {
    path: 'renuncia/consulta-protocolo',
    component: ProtocoloRenunciaPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
  },
];

@NgModule({
  imports:[RouterModule.forChild(routes)],
  exports:[RouterModule]
})
export class RenunciaRoutingModule { }

